import React from 'react';
import { Cross as CloseIcon } from '@periodica/ui-kit/icons';
import { Paragraph as P, Link as A } from '@periodica/ui-kit';

import * as styles from './styles.module.css';

type StrapiAlertLink = {
  id: string;
  linkUrl: string;
  linkText: string;
};

export type BannerAlertProps = {
  show: boolean;
  text: string;
  bgColor: string;
  links?: StrapiAlertLink[];
  onClose: () => void;
};

export function BannerAlert({ show, text, bgColor, links, onClose }: BannerAlertProps) {
  return show ? (
    <div className={styles.bannerAlert} style={{ backgroundColor: bgColor }}>
      <div className={styles.wrapper}>
        <P size="large" weight="emphasized">
          {text}
        </P>
        {links?.length ? (
          <P size="large" weight="emphasized" className={styles.linksContainer}>
            {links?.map((link: StrapiAlertLink) => (
              <A href={link.linkUrl} target="_blank" key={`alertLink_${link.id}`} rel="noreferrer">
                {link.linkText}
              </A>
            ))}
          </P>
        ) : null}
      </div>
      <button type="button" aria-label="Закрыть" className={styles.controls} onClick={onClose}>
        <CloseIcon size={20} />
      </button>
    </div>
  ) : null;
}
